import axios, { CancelTokenSource } from 'axios';
import { patchWhenAuthorized } from './api';


export const setEmailWhitelisted = async (personId: number, email: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        await patchWhenAuthorized(() => `/api/person/${personId}/whitelist`, {}, cancelTokenSource);

    } catch (error) {
        if (!axios.isCancel(error)) {
            console.error(`/api/person/${personId}/whitelist failed`);
        }
    }

    try {
        await patchWhenAuthorized(() => `/api/person/email/${email}/whitelist`, {}, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            console.error(`/api/person/email/${email}/whitelist failed`);
        }
    }

    return;
}